export default `
-- CreateIndex
CREATE INDEX "Attachment_child_type_idx" ON "Attachment"("child_type");

-- CreateIndex
CREATE INDEX "Attachment_child_id_idx" ON "Attachment"("child_id");

-- CreateIndex
CREATE INDEX "Attachment_parent_type_idx" ON "Attachment"("parent_type");

-- CreateIndex
CREATE INDEX "Attachment_parent_id_idx" ON "Attachment"("parent_id");

-- CreateIndex
CREATE INDEX "Attachment_created_by_idx" ON "Attachment"("created_by");

-- CreateIndex
CREATE INDEX "Attachment_created_at_idx" ON "Attachment"("created_at");

-- CreateIndex
CREATE INDEX "Attachment_updated_at_idx" ON "Attachment"("updated_at");

-- CreateIndex
CREATE INDEX "Attachment_workspace_id_idx" ON "Attachment"("workspace_id");

-- CreateIndex
CREATE INDEX "Comment_workspace_id_idx" ON "Comment"("workspace_id");

-- CreateIndex
CREATE INDEX "Comment_reply_parent_id_idx" ON "Comment"("reply_parent_id");

-- CreateIndex
CREATE INDEX "Comment_created_by_idx" ON "Comment"("created_by");

-- CreateIndex
CREATE INDEX "Comment_created_at_idx" ON "Comment"("created_at");

-- CreateIndex
CREATE INDEX "Comment_updated_at_idx" ON "Comment"("updated_at");

-- CreateIndex
CREATE INDEX "File_mime_type_idx" ON "File"("mime_type");

-- CreateIndex
CREATE INDEX "File_earliest_known_modified_at_idx" ON "File"("earliest_known_modified_at");

-- CreateIndex
CREATE INDEX "File_workspace_id_idx" ON "File"("workspace_id");

-- CreateIndex
CREATE INDEX "File_created_by_idx" ON "File"("created_by");

-- CreateIndex
CREATE INDEX "File_created_at_idx" ON "File"("created_at");

-- CreateIndex
CREATE INDEX "File_updated_at_idx" ON "File"("updated_at");

-- CreateIndex
CREATE INDEX "Project_workspace_id_idx" ON "Project"("workspace_id");

-- CreateIndex
CREATE INDEX "Project_type_idx" ON "Project"("type");

-- CreateIndex
CREATE INDEX "Project_created_by_idx" ON "Project"("created_by");

-- CreateIndex
CREATE INDEX "Project_created_at_idx" ON "Project"("created_at");

-- CreateIndex
CREATE INDEX "Project_updated_at_idx" ON "Project"("updated_at");

-- CreateIndex
CREATE INDEX "RawFile_workspace_id_idx" ON "RawFile"("workspace_id");

-- CreateIndex
CREATE INDEX "RawFile_file_id_idx" ON "RawFile"("file_id");

-- CreateIndex
CREATE INDEX "RawFile_created_by_idx" ON "RawFile"("created_by");

-- CreateIndex
CREATE INDEX "RawFile_created_at_idx" ON "RawFile"("created_at");

-- CreateIndex
CREATE INDEX "RawFile_updated_at_idx" ON "RawFile"("updated_at");

-- CreateIndex
CREATE INDEX "User_created_at_idx" ON "User"("created_at");

-- CreateIndex
CREATE INDEX "User_updated_at_idx" ON "User"("updated_at");

-- CreateIndex
CREATE INDEX "Workspace_owner_id_idx" ON "Workspace"("owner_id");

-- CreateIndex
CREATE INDEX "Workspace_created_by_idx" ON "Workspace"("created_by");

-- CreateIndex
CREATE INDEX "Workspace_created_at_idx" ON "Workspace"("created_at");

-- CreateIndex
CREATE INDEX "Workspace_updated_at_idx" ON "Workspace"("updated_at");

-- CreateIndex
CREATE INDEX "Workspace_type_idx" ON "Workspace"("type");

-- CreateIndex
CREATE INDEX "WorkspaceMember_workspace_id_idx" ON "WorkspaceMember"("workspace_id");

-- CreateIndex
CREATE INDEX "WorkspaceMember_user_id_idx" ON "WorkspaceMember"("user_id");

-- CreateIndex
CREATE INDEX "WorkspaceMember_created_by_idx" ON "WorkspaceMember"("created_by");

-- CreateIndex
CREATE INDEX "WorkspaceMember_created_at_idx" ON "WorkspaceMember"("created_at");
`;
